/**
 * 内联 SVG 图标集（stroke 风格，24x24 视窗）。
 * 全部为程序绘制路径，无任何位图/占位图依赖。
 */
import { cn } from '../lib/utils';

export type IconName =
  | 'dashboard'
  | 'tasks'
  | 'projects'
  | 'habits'
  | 'focus'
  | 'stats'
  | 'contacts'
  | 'vault'
  | 'settings'
  | 'plus'
  | 'bell'
  | 'sun'
  | 'moon'
  | 'lock'
  | 'menu'
  | 'close'
  | 'search'
  | 'star'
  | 'trash'
  | 'edit'
  | 'copy'
  | 'check'
  | 'calendar'
  | 'gift'
  | 'key'
  | 'refresh'
  | 'folder'
  | 'chevronLeft'
  | 'chevronRight'
  | 'logout'
  | 'eye'
  | 'eyeOff'
  | 'user'
  | 'inbox';

const PATHS: Record<IconName, string> = {
  dashboard: 'M4 4h7v7H4zM13 4h7v7h-7zM4 13h7v7H4zM13 13h7v7h-7z',
  tasks: 'M5 5h14v14H5zM8.5 12l2.5 2.5 5-5',
  projects: 'M3 7a2 2 0 012-2h4l2 2h8a2 2 0 012 2v8a2 2 0 01-2 2H5a2 2 0 01-2-2z',
  habits: 'M20 12a8 8 0 11-2.34-5.66M20 3.5V8h-4.5',
  focus: 'M12 21a9 9 0 100-18 9 9 0 000 18zM12 7.5V12l3 2',
  stats: 'M4 20h16M7.5 16v-4M12 16V8M16.5 16v-6',
  contacts: 'M9 11a3.5 3.5 0 100-7 3.5 3.5 0 000 7zM2.5 20a6.5 6.5 0 0113 0M16 4.7a3.5 3.5 0 010 6.6M21.5 20a6.5 6.5 0 00-4-6',
  vault: 'M12 3l7 3v5c0 4.5-3 8-7 10-4-2-7-5.5-7-10V6zM12 10.5a1.8 1.8 0 100 3.6 1.8 1.8 0 000-3.6z',
  settings:
    'M12 15.5a3.5 3.5 0 100-7 3.5 3.5 0 000 7zM12 2.5v2.5M12 19v2.5M2.5 12H5M19 12h2.5M5.2 5.2L7 7M17 17l1.8 1.8M18.8 5.2L17 7M7 17l-1.8 1.8',
  plus: 'M12 5v14M5 12h14',
  bell: 'M6 9a6 6 0 1112 0c0 5 2 6 2 6H4s2-1 2-6zM10 20a2 2 0 004 0',
  sun: 'M12 16a4 4 0 100-8 4 4 0 000 8zM12 2v2M12 20v2M4.2 4.2l1.5 1.5M18.3 18.3l1.5 1.5M2 12h2M20 12h2M4.2 19.8l1.5-1.5M18.3 5.7l1.5-1.5',
  moon: 'M20 14.5A8.5 8.5 0 019.5 4 8.5 8.5 0 1020 14.5z',
  lock: 'M7 11V8a5 5 0 0110 0v3M5 11h14v9H5z',
  menu: 'M4 7h16M4 12h16M4 17h16',
  close: 'M6 6l12 12M18 6L6 18',
  search: 'M11 18a7 7 0 100-14 7 7 0 000 14zM21 21l-4.3-4.3',
  star: 'M12 3.5l2.6 5.3 5.9.9-4.3 4.1 1 5.8-5.2-2.7-5.2 2.7 1-5.8-4.3-4.1 5.9-.9z',
  trash: 'M4 7h16M9 7V4.5h6V7M6 7l1 13h10l1-13M10 11v6M14 11v6',
  edit: 'M4 20h4L20 8l-4-4L4 16zM14 6l4 4',
  copy: 'M8 8h11v11H8zM5 16V5h11',
  check: 'M5 12l4.5 4.5L19 7',
  calendar: 'M4 7h16v13H4zM8 3v4M16 3v4M4 11h16',
  gift: 'M4 11h16v9H4zM3 7h18v4H3zM12 7v13M12 7C8 7 7 3 9.5 3S12 7 12 7zM12 7c4 0 5-4 2.5-4S12 7 12 7z',
  key: 'M16 8a4 4 0 11-8 0 4 4 0 018 0zM12 12v8M12 17h4',
  refresh: 'M4 12a8 8 0 0113.66-5.66L20 8M20 12a8 8 0 01-13.66 5.66L4 16M20 3.5V8h-4.5M4 20.5V16h4.5',
  folder: 'M3 7a2 2 0 012-2h4l2 2h8a2 2 0 012 2v8a2 2 0 01-2 2H5a2 2 0 01-2-2z',
  chevronLeft: 'M14 6l-6 6 6 6',
  chevronRight: 'M10 6l6 6-6 6',
  logout: 'M15 12H4M8 8l-4 4 4 4M13 4h6v16h-6',
  eye: 'M2 12s3.5-6 10-6 10 6 10 6-3.5 6-10 6-10-6-10-6zM12 15a3 3 0 100-6 3 3 0 000 6z',
  eyeOff: 'M4 4l16 16M10 6.3A9.8 9.8 0 0112 6c6.5 0 10 6 10 6a17 17 0 01-3.2 3.7M6.5 8.2C3.9 9.8 2 12 2 12s3.5 6 10 6c1.2 0 2.3-.2 3.3-.5',
  user: 'M12 11a3.5 3.5 0 100-7 3.5 3.5 0 000 7zM4 20a8 8 0 0116 0',
  inbox: 'M4 13h4l2 3h4l2-3h4M4 13l2.5-8h11L20 13v6H4z',
};

export function Icon({
  name,
  className,
  filled,
}: {
  name: IconName;
  className?: string;
  filled?: boolean;
}) {
  return (
    <svg
      className={cn('h-5 w-5', className)}
      viewBox="0 0 24 24"
      fill={filled ? 'currentColor' : 'none'}
      stroke="currentColor"
      strokeWidth={1.8}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <path d={PATHS[name]} />
    </svg>
  );
}
